import { useState } from "react";
import { Play, ExternalLink } from "lucide-react";
import VerifiedBadge from "./VerifiedBadge";

export default function VideoCard({ video }) {
  const [open, setOpen] = useState(false);
  if (!video) return null;
  const canEmbed = !!video.embed;
  return (
    <div className="video-card" data-testid={`video-card-${video.id}`}>
      <button
        type="button"
        className="video-thumb text-left"
        onClick={() => {
          if (canEmbed) setOpen(true);
          else window.open(video.link, "_blank", "noopener,noreferrer");
        }}
        data-testid={`video-play-${video.id}`}
      >
        <img src={video.thumbnail} alt={video.title} loading="lazy" />
        <span className="play"><span><Play size={20} fill="white" /></span></span>
        <span className="channel-badge">{video.channel}</span>
      </button>
      <div className="p-3">
        <h3 className="text-[15px] font-black leading-snug text-[var(--ink)] line-clamp-2">{video.title}</h3>
        <div className="flex items-center gap-2 mt-2 text-[11px] text-[var(--muted)] font-semibold uppercase tracking-wide">
          <span data-testid={`video-source-${video.id}`}>Source: {video.channel}</span>
          <VerifiedBadge name={video.channel} compact testId={`video-verified-${video.id}`} />
          <span>·</span>
          <span>{new Date(video.published).toLocaleDateString("en-US", { month: "short", day: "numeric" })}</span>
        </div>
      </div>

      {open && (
        <div className="modal-back" onClick={() => setOpen(false)} data-testid={`video-modal-${video.id}`}>
          <div className="modal !p-0 !max-w-[920px] bg-black" onClick={(e) => e.stopPropagation()}>
            <div className="relative" style={{ paddingTop: "56.25%" }}>
              <iframe
                className="absolute inset-0 w-full h-full"
                src={`${video.embed}?autoplay=1`}
                title={video.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="bg-white p-4 flex items-start justify-between gap-3">
              <div className="flex-1">
                <h3 className="text-[16px] font-black leading-tight">{video.title}</h3>
                <p className="text-[12px] text-[var(--muted)] mt-1 flex items-center gap-1.5" data-testid={`video-modal-source-${video.id}`}>
                  Source: <span className="font-bold text-[var(--ink)]">{video.channel}</span>
                  <VerifiedBadge name={video.channel} testId={`video-modal-verified-${video.id}`} />
                  <span>· {new Date(video.published).toLocaleDateString()}</span>
                </p>
                {video.link && (
                  <a href={video.link} target="_blank" rel="nofollow noopener noreferrer" referrerPolicy="no-referrer"
                     className="text-[11.5px] text-[var(--blue)] font-bold inline-flex items-center gap-1 mt-1"
                     data-testid={`video-watch-on-${video.id}`}>
                    <ExternalLink size={11} /> Watch on YouTube
                  </a>
                )}
              </div>
              <button className="btn" onClick={() => setOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
